import { SelectProps } from 'antd/es/select';
import { XmSelect } from './XmSelect';

/** Label of a class-level (pre HW type) selection in a HW type select. */
export const CROSS_PLATFORM_LABEL = 'Cross-platform';

type Props = SelectProps<string> & {
  ignoreReadonly?: boolean;
  /** Set for a legacy class-wide row: shown as {@link CROSS_PLATFORM_LABEL} instead of the empty value. */
  legacyCls?: string;
};

export function XmHwTypeSelect({ legacyCls, value, labelRender, ...rest }: Props) {
  return <XmSelect<string> {...rest} value={legacyCls ?? value} labelRender={legacyCls ? () => CROSS_PLATFORM_LABEL : labelRender} />;
}
